import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { fmtFecha, fmtHora } from "@/lib/format";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

export default function MapaFichajeDialog({ fichaje, onClose }) {
  if (!fichaje?.latitud) return null;
  const pos = [fichaje.latitud, fichaje.longitud];

  return (
    <Dialog open={!!fichaje} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Geolocalización del fichaje</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-zinc-500">
          {fichaje.usuario} · {fichaje.tipo} · {fmtFecha(fichaje.timestamp)} {fmtHora(fichaje.timestamp)}
        </p>
        <div className="overflow-hidden rounded-xl border">
          <MapContainer center={pos} zoom={16} style={{ height: "360px", width: "100%", zIndex: 0 }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" />
            <Marker position={pos}>
              <Popup>
                {fichaje.usuario}<br />
                {fichaje.tipo} · {fmtHora(fichaje.timestamp)}
              </Popup>
            </Marker>
          </MapContainer>
        </div>
        <a
          href={`https://www.google.com/maps?q=${fichaje.latitud},${fichaje.longitud}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-indigo-600 hover:underline"
        >
          Abrir en Google Maps
        </a>
      </DialogContent>
    </Dialog>
  );
}
